import React from "react";
import RequestAttachmentTable from "./components/RequestAttachmentTable";
import useRequestAttachment from "../actions/useRequestAttachment";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import Notification from "~/components/entities/notification/Notification";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";
import "../requests.scss";
const RequestAttachments = () => {
  const {
    attachment,
    loading,
    rows,
    totalRecords,
    onPageChange,
    handleOpenDialog,
    isDataAvailable,
    first,
    handleDeleteDocument,
    attachmentConfirmModal,
    setAttachmentConfirmModal,
    handleConfirmDelete,
    handleRestoreAttachment,
    temporaryMessage,
    isAttachmentLoader,
    successMessage,
    setSuccessMessage,
    restoreMessage,
    setRstoreMessage,
    setTemporaryMessage,
  } = useRequestAttachment();
  return (
    <div className="attachment__tab--container">
      <Notification
        successMessage={successMessage}
        setSuccessMessage={setSuccessMessage}
      />
      <AttachmentSuccess
        successMsg={restoreMessage}
        setMessages={setRstoreMessage}
      />
      <TemporaryNotification
        onUndo={handleRestoreAttachment}
        successMsg={temporaryMessage}
        setMessages={setTemporaryMessage}
      />
      <RequestAttachmentTable
        attachment={attachment}
        loading={loading}
        rows={rows}
        totalRecords={totalRecords}
        onPageChange={onPageChange}
        handleOpenDialog={handleOpenDialog}
        isDataAvailable={isDataAvailable}
        first={first}
        handleAttachmentDelete={handleDeleteDocument}
        attachmentConfirmModal={attachmentConfirmModal}
        setAttachmentConfirmModal={setAttachmentConfirmModal}
        handleConfirmDelete={handleConfirmDelete}
      />
      {attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={attachmentConfirmModal}
          closeModal={() => setAttachmentConfirmModal(false)}
          handleSave={handleConfirmDelete}
          isLoader={isAttachmentLoader}
        />
      )}
    </div>
  );
};

export default RequestAttachments;
